module.exports = __webpack_public_path__ + "img/avatar-s-2.97e2f3fc.jpg";